import { useCoreContext } from 'modules/frequencyManagement/contexts/CoreContext';
import { SupportedMediums } from 'modules/frequencyManagement/lib/types';
import { supportedMediums } from 'modules/frequencyManagement/lib/utils/mediumDomainUtils';
import { FixedWidth } from 'ui/utility/fixedWidth';
import { TabsContent } from 'ui/tabsGroup';
import { Error } from './Error';
import { NotConfigured } from './NotConfigured';
import { Loading } from './Loading';
import { FrequencyManagementForm } from './FrequencyManagementForm';

export const MainContent = ({ messageMedium }: { messageMedium: SupportedMediums }) => {
  const { frequencyManagementData, isLoading, isError } = useCoreContext();
  const mediumConfig = frequencyManagementData?.[messageMedium];

  if (isLoading) return <Loading messageMedium={messageMedium} />;

  if (isError) return <Error />;

  if (!mediumConfig?.isConfiguredForSending) return <NotConfigured messageMedium={messageMedium} />;

  return (
    <FixedWidth>
      {supportedMediums.map((medium) => (
        <TabsContent key={medium} value={medium}>
          <FrequencyManagementForm
            mediumConfig={mediumConfig}
            messageMedium={medium as SupportedMediums}
          />
        </TabsContent>
      ))}
    </FixedWidth>
  );
};
